module.exports = __webpack_public_path__ + "img/sheji.b6b9758f.png";